import {Record} from 'immutable';

const OpeningHours = Record({
    fromHour: undefined,
    fromMinute: undefined,
    toHour: undefined,
    toMinute: undefined,
    open: undefined,
    day: undefined,
});

const fromAPI = data => {
    return new OpeningHours(data);
};

export default {
    record: OpeningHours,
    default: new OpeningHours(),
    fromAPI,
};
